import Css from './Customer.module.css';
import { Row, Col, Form, Button, Tab, Table, InputGroup } from "react-bootstrap";
import React from 'react';
import { useState, useEffect } from 'react';
import ApiConection from 'api_ref/ApiConection';
import { AddCommar, ConvertDateTimeToText, ConvertDateToText } from 'components/MyControl';
import { Link, useNavigate } from "react-router-dom";

export default function AdminTable({ path, title, search, handleSetSearch, dataList, pagination }) {
    const api = new ApiConection();

    const navigate = useNavigate();

    const handleClickDetail = (row, title, register) => {
        navigate(`${path}${row}`);
    }

    const handleSetOrderBy = (event) => {
        const name = event.target.dataset.name;

        handleSetSearch('order_by', name);
        handleSetSearch('page', 1);
        if (search?.order_mode == 'asc')
            handleSetSearch('order_mode', 'desc');
        else
            handleSetSearch('order_mode', 'asc');
    }

    const getOrderBy = (name) => {
        if (search?.order_by === name) {
            if (search?.order_mode === 'asc') {
                return <i className="ms-2 fa-solid fa-sort-down text-danger"></i>
            } else {
                return <i className="ms-2 fa-solid fa-sort-up text-danger"></i>
            }
        }
    }

    //console.log(dataList);
    return (
        <div className={Css.Content}>
            <div className="table-responsive border rounded">
                <table className="table text-nowrap mb-0">
                    <thead className="table-light">
                        {/*<tr>
                        <th colSpan={2}></th>
                        <th colSpan={8} style={{borderRight:'1px solid #ccc'}}>Customer</th>
                        <th colSpan={3}>บัญชีดำเนินการ</th>
                    </tr>*/}
                        <tr >
                            <th> </th>
                            <th > </th>
                            <th className='text-start' data-name={'QuontationNumber'} onClick={event => handleSetOrderBy(event)}>ใบสั่งซื้อ{getOrderBy('QuontationNumber')}</th>
                            <th className='text-center' data-name={'CreateDate'} onClick={event => handleSetOrderBy(event)}>วันที่{getOrderBy('CreateDate')}</th>
                            <th className='text-center ' data-name={'CompanyName'} onClick={event => handleSetOrderBy(event)}>ชื่อลูกค้า{getOrderBy('CompanyName')}</th>
                            <th className='text-center ' data-name={'PackageName'} onClick={event => handleSetOrderBy(event)}>แพ็กเกจ{getOrderBy('PackageName')}</th>
                            <th className='text-start ' data-name={'GrandTotalSubWithHoldingTax'} onClick={event => handleSetOrderBy(event)}>จำนวนเงิน{getOrderBy('GrandTotalSubWithHoldingTax')}</th>
                            <th className='text-center ' data-name={'DueDate'} onClick={event => handleSetOrderBy(event)} >วันที่ครบกำหนด{getOrderBy('DueDate')}</th>
                            <th className='text-center ' data-name={'PaidDate'} onClick={event => handleSetOrderBy(event)}>วันที่ชำระเงิน{getOrderBy('PaidDate')}</th>
                            <th className='text-center border-end' data-name={'PaymentStatusName'} onClick={event => handleSetOrderBy(event)} >สถานะลูกค้า{getOrderBy('PaymentStatusName')}</th>
                            <th className='text-center' data-name={'IssuedInvoiceMemo'} onClick={event => handleSetOrderBy(event)}>ใบแจ้งหนี้{getOrderBy('IssuedInvoiceMemo')}</th>
                            <th className='text-center ' data-name={'IssuedReceiptMemo'} onClick={event => handleSetOrderBy(event)}>ใบเสร็จรับเงิน{getOrderBy('IssuedReceiptMemo')}</th>
                            <th className='text-center ' data-name={'AuditStatusName'} onClick={event => handleSetOrderBy(event)}>สถานะเอกสาร{getOrderBy('AuditStatusName')}</th>
                        </tr>
                    </thead>
                    <tbody >
                        {dataList?.map((row, index) => (
                            <tr key={index}>
                                <td className=' text-center' width={60}>
                                    <Button className={Css.btncolor1} onClick={(_) => handleClickDetail(row.quontation_number)}>
                                        <i className={"fa-solid fa-magnifying-glass "}></i>
                                    </Button></td>
                                <td className='text-center' width={25}>{pagination?.record_start + index}</td>
                                <td className='text-start ' width={115}>{row.quontation_number}</td>
                                <td className='text-center ' width={120}>{ConvertDateToText(row.create_date)}</td>
                                <td className='text-center ' width={90}>{row.payee_name}</td>
                                <td className='text-start  ' width={100}>
                                    {/*row.package_master_name_short*/}
                                    {
                                        row?.arr_package?.map((detail, index) => (
                                            <span className='d-block' key={index}><pre>{detail?.package_master_name_short}</pre></span>
                                        ))
                                    }
                                </td>
                                <td className='text-end ' width={70}>{AddCommar(row?.grand_total_sub_withholding_tax?.toFixed(2))}</td>
                                <td className='text-center ' width={110}>{ConvertDateToText(row?.due_date)}</td>
                                <td className='text-center ' width={110}>{ConvertDateToText(row?.paid_date)}</td>
                                <td className='text-center border-end' width={200}><pre>{row.payment_status_name}</pre></td>
                                <td className='text-center ' width={120}>{row?.issued_invoice_memo}</td>
                                <td className='text-center ' width={120}>{row?.issued_receipt_memo}</td>
                                <td className='text-center ' width={120}>{row?.audit_status_name}</td>
                            </tr>

                        ))}

                    </tbody>
                </table>
            </div>
        </div>
    )
}